module.exports = __webpack_public_path__ + "static/06-3d-model-ab445fa931f41baf16832cc10b0a96d5.png";